/** Руководство пользователя CRM для владельцев клубов (Яндекс Объектное хранилище). */
export const CRM_USER_GUIDE_URL =
  "https://storage.yandexcloud.net/baycodepublic/%D0%A0%D1%83%D0%BA%D0%BE%D0%B2%D0%BE%D0%B4%D1%81%D1%82%D0%B2%D0%BE%20%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8F%20CRM.docx";

export const CRM_USER_GUIDE_LABEL = "Руководство пользователя";

export const CRM_USER_GUIDE_HINT = "Как вести клуб в Бай.Спорт";
